import React, { useState, useEffect } from "react";
import axios from "axios";
import {API_URL,FAST_API_URL} from "../api"


const CareChatbotPopup = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");

  const sendMessage = async (msg = input) => {
    if (!msg && messages.length > 0) return;
    let headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };

    const res = await axios.post(`${API_URL}/chat`, 
        {message: msg}, { headers: headersList }
    )

    if (msg) {
      setMessages(prev => [...prev, { text: msg, sender: "user" }]);
    }

    setMessages(prev => [
      ...prev,
      { text: res.data.message, sender: "ai" }
    ]);

    setInput("");

    if (res.data.risk === "high") {
      alert("🚨 Emergency! Contact doctor!");
    }
  };

  useEffect(() => {
    if (open && messages.length === 0) {
      sendMessage(""); // first AI message
    }
  }, [open]);

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setOpen(!open)}
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 z-50"
      >
        🤖
      </button>

      {/* Chat Popup */}
      {open && (
        <div className="fixed bottom-20 right-6 w-80 h-96 bg-white shadow-xl rounded-xl flex flex-col z-50">
          
          {/* Header */}
          <div className="bg-blue-600 text-white p-3 rounded-t-xl flex justify-between">
            <span>AI Care Assistant</span>
            <button onClick={() => setOpen(false)}>✖</button>
          </div>

          {/* Messages */}
          <div className="flex-1 overflow-y-auto p-3">
            {messages.map((m, i) => (
              <div key={i} className={`my-2 ${m.sender === "user" ? "text-right" : ""}`}>
                <span
                  className={`inline-block px-3 py-2 rounded-lg ${
                    m.sender === "user"
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200"
                  }`}
                >
                  {m.text}
                </span>
              </div>
            ))}
          </div>

          {/* Input */}
          <div className="flex border-t">
            <input
              className="flex-1 p-2 outline-none"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Type message..."
            />
            <button
              onClick={() => sendMessage()}
              className="bg-blue-600 text-white px-4"
            >
              Send
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CareChatbotPopup;